import { useSelector } from "react-redux";
import { RootState } from "../ducks/reducers";

export const useArgsSelector = <A extends unknown[] | [], R extends unknown>(
  selector: (store: RootState, ...selectorArgs: A) => R,
  ...args: A
): R => {
  return useSelector<RootState, R>(state => selector(state, ...args));
};
